<template>
  <div class="home-wrapper">
    <!-- 背景动画 -->
    <img src="../assets/img/img2.png" class="icon-top-img" />
    <img src="../assets/img/bg.png" class="time-line-box-bg" />
    <img src="../assets/img/img1.png" class="icon-top-img1" />
    <span class="text-bottom">封面新闻出品</span>
    <div class="share-box" @click="clickRight()">
      <img src="../assets/img/share.png" />
    </div>
    <!-- 中间部分 -->
    <div class="time-line-box" ref="timeLineBox">
      <div class="center-box" ref="scrollDiv" @scroll="scrollEvent">
        <div class="center">
          <div
            class="center-item"
            v-for="(val, key, index) in yearArr"
            :key="key"
          >
            <div class="year" v-if="index == 0">
              <p class="content">{{ capitalizeStart(key) }}</p>
            </div>
            <div
              :class="`year-content status${status}`"
              v-for="history in val"
              :key="history.info.title"
            >
              <p :class="`vertical-line status${status}`"></p>
              <img src="../assets/img/center.png" class="icon" />
              <p class="line"></p>
              <div
                class="name-box"
                @click="openHistory(history.info.title, history.info.news_id)"
              >
                <span class="empty"></span>
                <div class="text">
                  <span>{{ history.info.subtitle }}</span>
                </div>
              </div>
            </div>
            <div class="year" v-if="val.length > 0">
              <p class="content">{{ capitalizeEnd(key) }}</p>
            </div>
          </div>
        </div>
      </div>
      <!-- <div class="bottom">
        <img src="../assets/img/img3.png" class="bottom-img" />
      </div> -->
    </div>
    <!-- 弹窗，百年百篇详情 -->
    <div
      class="history-flag"
      v-if="historyVisible"
      @click.self="closeHistory()"
    >
      <div class="flag-content">
        <img
          src="../assets/img/close.png"
          class="history-close"
          @click.prevent="closeHistory()"
        />
        <div class="flag-center">
          <p class="history-head">
            <img src="../assets/img/img2.png" class="flag-head-img1" />
            <span class="flag-head-line"></span>
            <img src="../assets/img/history.png" class="flag-head-img2" />
          </p>
          <div class="scroll-box">
            <p class="history-title">{{ historyTitle }}</p>
            <p class="history-content details" v-html="historyContent" @click="gohistory"></p>
          </div>
        </div>
      </div>
    </div>
    <!-- 海报 -->
    <div class="poster-box" v-if="showPosterBox" @click="clickRight()">
      <div class="poster-info">
        <img
          class="poster-img"
          :src="posterImg"
          alt=""
          @click.stop="posterImgClick"
        />
        <p class="save-tips-text">
          {{ isApp ? "点击图片分享海报" : "长按图片保存到手机" }}
        </p>
      </div>
    </div>
    <!-- 开机图 -->
    <div class="access-images" v-if="access" @click="accessPage()">
      <img
        src="../assets/img/access.jpg"
      />
    </div>
  </div>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";
import { mapState } from "vuex";
import COVERAPP from "@/utils/COVERAPP";
@Options({
  data() {
    return {
      // 事件list 第一维度
      yearArr: [],
      // 事件缩放颗粒
      status: 1,
      //弹框数据
      historyTitle: "",
      historyContent: "",
      historyId: "",
      historyVisible: false,
      showPosterBox: false,
      posterImg: "",
      statusChange: false, //控制动画
      isApp: false,
      openVisible: true,
      access:true//开机图
    };
  },
  computed: {
    ...mapState(["userInfo", "shareData", "activityData"]),
  },
  mounted() {
    let self = this;
    let homeShareData = JSON.parse(JSON.stringify(this.shareData));
    homeShareData.link = window.location.href;
    this.isApp = COVERAPP.Attribute.isApp();
    this.$common.onshare(homeShareData);
    this.getDetail();
  },
  watch: {
    yearArr(val, oldVal) {
      //普通的watch监听
      let self = this;
      self.$nextTick(function () {
        self.addNum();
      });
    },
  },
  methods: {
    // 页面指南关闭
    closeOpen() {
      this.openVisible = false;
    },
    // 数据格式化
    getDetail() {
      let self = this;
      self
        .$requestTime(
          "https://actapi.thepage.cn/vote?aid=60a71b02494472004175b5c1&rows=1000",
          {},
          "get"
        )
        .then((data) => {
          if (data.total && data.total > 0) {
            let list = data.list;
            console.log("newArr1", list);
            // 数据处理
            let newList = self.dataSort(list);
            console.log("排序后", newList);
            // 排序后的数据按照年份分组
            let yearArr = self.yearFormat(newList, 1);
            self.yearArr = yearArr;
            self.getLength(this.yearArr);
            console.log("year1", yearArr);
            self.$common.pageLoaded();
            this.$common.track("load", "进入百年百篇时间轴页面"); //埋点
          }
        })
        .catch((res: any) => {});
    },
    dataSort(datalist: Array<any>) {
      let newArr = datalist.sort(function (a, b) {
        let key1 = +(+(a.info.year* 10000) + a.info.news_id + '.' + a.votes)
        let key2 = +(+(b.info.year* 10000) + b.info.news_id + '.' + b.votes)
        return key1 - key2; //升序排列，return b-a; —>升序排列
      });
      return newArr
    },
    yearFormat(yearArr: Array<any>, status: number) {
      let yearLength = yearArr.length;
      let yearList = {};
      for (let i = 2021; i > 1920; i -= status) {
        let smallYear = i - status;
        let key = i + "-" + smallYear;
        yearList[key] = [];

        for (let j = 0; j < yearLength; j++) {
          let year = parseInt(yearArr[j].info.year);
          if (year == i && i == 2021) {
            yearList[key].push(yearArr[j]);
          } else if ((year < i && year > smallYear) || year == smallYear) {
            yearList[key].push(yearArr[j]);
          } else if (year == smallYear && smallYear == 1920) {
            yearList[key].push(yearArr[j]);
          }
        }
      }
      return yearList;
    },
    addNum() {
      let arr = document.getElementsByClassName("year-content");
      let len = arr.length;
      for (let i = 0; i < len; i++) {
        i % 2 ? arr[i].classList.add("even") : arr[i].classList.add("odd");
      }
    },
    openHistory(name: string, id: string) {
      this.$common.track("click", `百年百篇时间轴"${name}"事件被点击，id:"${id}"`); //埋点
      this.historyTitle = name;
      this.historyId = id;
      let self = this;
      // 测试环境
      // let apiBaseUrl = "https://cover-api.fm-dev.thecover.cn";
      let apiBaseUrl = "https://api.thecover.cn";

      // 正式环境
      if (location.href.indexOf("h5.thepage.cn") > -1) {
        apiBaseUrl = "https://api.thecover.cn";
      }
      self
        .$http(
          apiBaseUrl + "/wap/getDetail",
          {
            news_id: id,
            diversion_id: "",
            expireTimestampSign: "",
          },
          "post"
        )
        .then((data: any) => {
          // console.log("新闻数据", data.content);
          let content = data.content;
          if(content){
             self.historyContent= self.deleteA( content);
          }
        });
      this.historyVisible = true;
    },
    gohistory(event){
      let target = event.target
      let id = target.getAttribute('data-id')
      if(target.className ==='wiki' && id){
        window.location.href = `https://m.thecover.cn/history.html?id=${id}`
      }
    },
    // 百科内容清除第三方链接
    deleteA: function (data) {
        let pattern = new RegExp('href=\"cyclopedia:\/\/id=[0-9A-Za-z]+\"', "g");
        let newData = data.replace(pattern, 'href="javascript:;"');
        return newData;
    },
    closeHistory() {
      this.historyTitle = "";
      this.historyContent = "";
      this.historyId = "";
      this.historyVisible = false;
    },
    // 年份展示
    getLength(obj: object) {
      let num = 0;
      for (var item in obj) {
        num++;
      }
      this.yearListLength = num;
    },
    capitalizeStart: function (value) {
      return value.substring(0, 4);
    },
    capitalizeEnd: function (value) {
      return value.substring(5);
    },
    // 显示或隐藏海报、右侧按钮点击放到到最大颗粒且滑动到最小年
    clickRight() {
      let self = this;
      //海报
      if (!this.showPosterBox) {
        self.drawPoster();
        self.$common.track("click", `点击时间轴分享海报`); //埋点
      } else {
        self.showPosterBox = false;
      }
    },
    /*以下为生成分享图*/
    drawPoster() {
      let canvas = document.createElement("canvas");
      canvas.width = 1005;
      canvas.height = 1608;
      let ctx: any = canvas.getContext("2d");
      var posterImgs: any = [];
      posterImgs.push(
        this.defPreImage(require("../assets/img/map-poster.png"))
      );
      posterImgs.push(this.defPreImage(require("../assets/img/qrcode.png")));
      var that = this;
      Promise.all(posterImgs).then((imgs: any) => {
        ctx.drawImage(
          imgs[0],
          0,
          0,
          imgs[0].width,
          imgs[0].height,
          0,
          0,
          imgs[0].width,
          imgs[0].height
        );
        ctx.drawImage(
          imgs[1],
          0,
          0,
          imgs[1].width,
          imgs[1].height,
          1005 - imgs[1].width - 40,
          1588 - imgs[1].height,
          imgs[1].width,
          imgs[1].height
        );

        //绘制字体
        ctx.font = 'bold 60px "Helvetica"';
        ctx.fillStyle = "white";
        // 设置水平对齐方式
        ctx.textAlign = "left";
        // 设置垂直对齐方式
        ctx.textBaseline = "middle";
        ctx.fillText("我是百年百篇时间轴", 50, 980);
        ctx.fillText("第", 50, 1125);
        ctx.fillText("期待您的加入，共觅岁月峥嵘！", 50, 1250);

        //绘制字体
        ctx.font = 'bold 120px "Helvetica"';
        ctx.fillStyle = "white";
        // 设置水平对齐方式
        ctx.textAlign = "left";
        // 设置垂直对齐方式
        ctx.textBaseline = "middle";
        // 设置为粗体
        var beginTime = 1622476800;//正式环境2021-06-01 00:00:00
        var textNum =
          10000 +
          Math.round((Math.round(Date.now() / 1000) - beginTime) * 0.183);
        ctx.fillText(textNum, 150, 1110);

        var numberWidth = ctx.measureText(textNum).width;
        //绘制字体
        ctx.font = 'bold 60px "Helvetica"';
        ctx.fillStyle = "white";
        // 设置水平对齐方式
        ctx.textAlign = "left";
        // 设置垂直对齐方式
        ctx.textBaseline = "middle";
        ctx.fillText("位探秘者", 180 + numberWidth, 1125);

        this.posterImg = canvas.toDataURL("image/jpeg");
        this.showPosterBox = true;
      });
    },
    //加载图片
    defPreImage(imgPath) {
      return new Promise((resolve, reject) => {
        let img = new Image();
        img.onload = function () {
          resolve(img);
        };
        img.crossOrigin = "Anonymous";
        img.src = imgPath;
      });
    },
    // 点击海报分享图片
    posterImgClick(e) {
      // console.log("点击图片");
      const _this = this;
      COVERAPP.Method.shareImage({
        image: e.target.src.split(";base64,")[1],
        title: _this.shareData.title,
        desc: _this.shareData.desc,
        imgUrl: _this.shareData.imgUrl,
        link: _this.shareData.link,
        callback(ret: any) {
          // const data = typeof ret == 'string'.toLowerCase() ? JSON.parse(ret) : ret
          // const origin = data.origin || ''
          // if (origin != 'None' && !_this.$common.isEmpty(origin)) {
          //     _this.$common.track('share', '分享图片到' + origin)
          // } else {
          //     _this.$common.track('share', '分享图片');
          // }
        },
      });
    },
    // 进入页面
    accessPage(){
       this.access = false;
    }
  },
})
export default class Home extends Vue {}
</script>

<style lang="scss">
.home-wrapper {
  position: relative;
  height: 100%;
  width: 100%;
  overflow: hidden;
  background: url(../assets/img/backgound.png) top left no-repeat;
  background-size: 100% 100%;
}
// 背景
.icon-top-img,
.icon-top-img1,
.text-bottom,
.share-box,
.time-line-box-bg {
  position: absolute;
}
.icon-top-img {
  top: 0.86rem;
  left: 0.64rem;
  width: 3.2rem;
}
.icon-top-img1 {
  top: 0.86rem;
  left: 50%;
  width: 2.6rem;
  transform: translateX(-50%);
}
.text-bottom {
  bottom: 0.64rem;
  left: 0.64rem;
  font-size: 0.54rem;
  color: #7e5439;
  font-weight: 500;
  // text-shadow: 1px 1px 0px #353535;
}
.time-line-box-bg {
  width: 7.2rem;
  height: 100%;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
}
.share-box {
  right: 0.64rem;
  bottom: 0.64rem;
  width: 4.48rem;
  height: 1.92rem;
}
.share-box img {
  width: 4.48rem;
  height: 1.92rem;
}
// 内容
// 内容顶部
.time-line-box {
  width: 100%;
  height: 100%;
  display: flex;
  display: -webkit-flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 3.6rem 0 3.2rem;
  box-sizing: border-box;
  // background: url("../assets/img/bg.png") no-repeat;
  // background-size: 3.6rem 100%;
  // background-position: 50%;
  min-height: 100%;
}
.time-line-box .top {
  position: relative;
  width: 7.2rem;
  height: 4rem;
  text-align: center;
  flex: 0;
  box-shadow: 0px 10px 5px #b62e2d inset;
}
.time-line-box .top .content {
  width: 7.2rem;
  height: 4rem;
}
.time-line-box .top .top-img {
  position: absolute;
  width: 2.62rem;
  top: 0.86rem;
  left: 50%;
  transform: translateX(-50%);
  z-index: 1;
}
.time-line-box .top .top-bg {
  position: absolute;
  width: 7.2rem;
  top: 0;
  left: 0;
  z-index: 0;
}
// 内容中部
.time-line-box .center-box {
  position: relative;
  flex: 1;
  overflow-y: scroll;
  overflow-x: hidden;
  width: 100%;
}
.time-line-box .center {
  margin: 0 auto;
  // width: 7.39rem;
  // background-image: linear-gradient(
  //   180deg,
  //   rgba(182, 46, 45, 1) 0%,
  //   rgba(182, 46, 45, 0) 100%
  // );
  // background-size: 3.6rem 100%;
  // background-position: 50%;
  // background-repeat: no-repeat;
  min-height: 100%;
}
// 每个阶段
.time-line-box .center .center-item {
  // height: 15vh;
  width: 14.78rem;
  // width: 100%;
  font-size: 0.64rem;
  margin: 0 auto;
}
.time-line-box .center .center-item .year {
  position: relative;
  text-align: center;
  font-size: 0.64rem;
  font-weight: bold;
  color: #ffeac3;
  height: 1.06rem;
  line-height: 1.06rem;
  text-shadow: 1px 1px 0px #353535;
}
.time-line-box .center .center-item .year .content {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
}
.time-line-box .center .center-item .year-content {
  position: relative;
  height: 2.64rem;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 0;
}
.time-line-box .center .center-item .year-content.even{
  flex-direction: row;
  padding-left: 50%;
}
.time-line-box .center .center-item .year-content.odd{
  flex-direction: row-reverse;
  padding-right: 50%;
}
.time-line-box .center .center-item .year-content.status1 {
  margin-top: -1rem;
}
.time-line-box .center .center-item .year-content:nth-of-type(1) {
  margin-top: 0;
}
.time-line-box .center .center-item .year-content .vertical-line {
  position: absolute;
  left: 50%;
  width: 3px;
  background: #ffdc9d;
  z-index: 0;
  transform: translateX(-50%);
}
.time-line-box .center .center-item .year-content .vertical-line.status1 {
  height: 1.641rem;
}
.time-line-box .center .center-item .year-content .icon {
  position: absolute;
  z-index: 1;
  width: 0.48rem;
  left: 50%;
  transform: translateX(-50%);
}
.time-line-box .center .center-item .year-content .line {
  width: 1.86rem;
  height: 1px;
  background: rgba(255, 243, 222, 0.37);
}
.time-line-box .center .center-item .year-content .name-box {
  width: 5.34rem;
  padding: 0 0.42rem;
  height: 2.64rem;
  box-sizing: border-box;
  background: rgba(9, 16, 29, 0.71);
  border-radius: 0.54rem;
  border: 0.06rem solid #ffdc9d;
}
.time-line-box .center .center-item .year-content .name-box-new {
  width: 5.34rem;
  padding: 0 0.42rem 0.42rem;
  height: 2.98rem;
  box-sizing: border-box;
  background: rgba(9, 16, 29, 0.71);
  border-radius: 0;
  border: none;
  // background: url("../assets/img/name-box-new.png") no-repeat top left;
  background-size: cover;
}
.time-line-box .center .center-item .year-content .name-box .empty {
  vertical-align: middle;
  display: inline-block;
  height: 100%;
}
.time-line-box .center .center-item .year-content .name-box .text {
  vertical-align: middle;
  display: inline-block;
}
.time-line-box .center .center-item .year-content .name-box .text span {
  max-height: 1.92rem;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  font-weight: 500;
  color: #fff2d9;
  font-size: 0.64rem;
  line-height: 0.96rem;
}
// 内容底部

.time-line-box .bottom {
  flex: 0;
  width: 7.2rem;
  height: 5.46rem;
  text-align: center;
}
.time-line-box .bottom .bottom-img {
  width: 100%;
}
/* 弹窗 百年百篇详情 */
.history-flag {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;
  height: 100%;
  width: 100%;
  background: rgba(0, 0, 0, 0.3);
  display: -webkit-flex;
  display: flex;
  -webkit-align-items: baseline;
  align-items: baseline;
}
.history-flag .flag-content {
  background: #fff;
  border-radius: 0.483092rem;
  text-align: center;
  font-size: 0.8rem;
  padding: 0.9rem 0.8rem;
  width: 84%;
  box-sizing: border-box;
  position: fixed;
  top: 10%;
  left: 8%;
}

.history-flag .history-close {
  position: absolute;
  width: 0.64rem;
  height: 0.64rem;
  top: 0.64rem;
  right: 0.64rem;
}
.history-flag .history-close.hidden {
  display: none;
}

.history-flag .flag-center {
  word-break: break-all;
  font-size: 0;
}
.history-flag .history-head {
  display: flex;
  justify-content: center;
  align-items: center;
  padding-bottom: 0.43rem;
}
.history-flag .flag-head-img1 {
  width: 2.14rem;
}
.history-flag .flag-head-line {
  display: inline-block;
  width: 0.06rem;
  height: 1.22rem;
  margin: 0 0.48rem 0 0.54rem;
  background: #ffd8d8;
}
.history-flag .flag-head-img2 {
  width: 4.26rem;
  margin-top: -0.2rem;
}
.history-flag .scroll-box {
  overflow-y: scroll;
  overflow-x: hidden;
}
.history-flag .history-title {
  font-size: 1.28rem;
  font-weight: 500;
  text-align: left;
  padding: 0.43rem 0 0.42rem;
  // word-break: break-all;
  // overflow: hidden; // 超出的文本隐藏
  // text-overflow: ellipsis; // 溢出用省略号显示
  // white-space: nowrap; // 溢出不换行
}

.history-flag .history-content {
  height: 18rem;
  line-height: 1.28rem;
  // overflow-y: scroll;
  font-size: 0.8rem;
  text-align: left;
  color: #4b525c;
}
.poster-box {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba($color: #000000, $alpha: 0.7);
  z-index: 90;
  .poster-info {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translateX(-50%) translateY(-50%);
    .poster-img {
      width: 85.28vw;
      display: block;
      margin: 0 auto;
      border-radius: 1.85vw;
    }
    .save-tips-text {
      font-size: 3.33vw;
      font-family: PingFang SC;
      font-weight: 500;
      color: #ffffff;
      line-height: 4.44vw;
      text-align: center;
      margin-top: 3.52vw;
    }
  }
}
.history-flag .history-content.details {
  font-size: 16px !important;
  font-family: -apple-system, "Hiragino Sans GB", Roboto, "Droid Sans",
    "Microsoft YaHei", "Microsoft YaHei UI", "Microsoft JhengHei UI", STHeiti,
    Oxygen, Ubuntu, Cantarell, "Fira Sans", "Helvetica Neue", sans-serif;
  color: #474747;
}

.history-flag .history-content.details p {
  font-family: -apple-system, "Hiragino Sans GB", Roboto, "Droid Sans",
    "Microsoft YaHei", "Microsoft YaHei UI", "Microsoft JhengHei UI", STHeiti,
    Oxygen, Ubuntu, Cantarell, "Fira Sans", "Helvetica Neue", sans-serif !important;
  -webkit-box-sizing: border-box !important;
  -moz-box-sizing: border-box !important;
  box-sizing: border-box !important;
}

.history-flag .history-content.details p,
.history-flag .history-content.details span,
.history-flag .history-content.details p.formatted,
.history-flag .history-content.details p.formatted span {
  font-size: 0.91787439rem !important;
  line-height: 1.6 !important;
  margin-bottom: 1.4492753rem;
  text-align: left;
}

.history-flag .history-content.details p:empty {
  display: none;
}

.history-flag .history-content.details img {
  max-width: 100%;
}
a {
    background-color: transparent;
    text-decoration: none;
    cursor: pointer;
    outline-width: 0;
}
a:active, a:hover, a,:visited{
    outline-width: 0;
    text-decoration: none;
}
.access-images{
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 998;
}
.access-images img{
  width: 100vw;
  height: 100vh;
}
</style>
